module.exports = __webpack_public_path__ + "static/img/baojingjiechu.22bda50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/baojingjiechu.png
// module id = S9j3
// module chunks = 24